<section [style]="styles">
  @if (labelEnabled) {
    <blaze-element-label
      [color]="props?.style?.general?.title?.color1"
      [extendInputPadding]="elementContext?.extendInputPadding"
      [fontFamily]="props?.style?.labelBlock?.fontFamily"
      [fontSize]="props?.style?.labelBlock?.fontSize"
      [fontStyle]="props?.style?.labelBlock?.fontStyle"
      [fontWeight]="props?.style?.labelBlock?.fontWeight"
      [horizontalAlign]="props?.content?.title?.align"
      [icon]="props?.content?.title?.icon"
      [iconColor]="props?.content?.title?.iconColor?.color1"
      [iconPosition]="props?.content?.title?.iconPosition"
      [iconSize]="props?.style?.labelBlock?.iconSize"
      [isUsingOldPaddingStrategy]="isUsingOldPaddingStrategy"
      [lineHeight]="props?.style?.labelBlock?.lineHeight"
      [position]="props?.content?.title?.position"
      [tooltip]="props?.content?.title?.tooltip"
      [width]="props?.content?.title?.width"
      verticalAlign="top"
    >
      {{ labelText }}
    </blaze-element-label>
  }
  <div class="input-wrapper" [style]="inputWrapperStyles">
    <blaze-scroller class="scroller">
      @switch (mode) {
        @case ('text') {
          <ng-container *ngTemplateOutlet="textTpl" />
        }
        @case ('image') {
          <ng-container *ngTemplateOutlet="imageTpl" />
        }
        @case ('box') {
          <ng-container *ngTemplateOutlet="imageTpl" />
        }
        @case ('chip') {
          <ng-container *ngTemplateOutlet="imageTpl" />
        }
        @case ('card') {
          <ng-container *ngTemplateOutlet="imageTpl" />
        }
      }
    </blaze-scroller>
  </div>
</section>

@if (hasValidationError) {
  <div class="validation" [style]="validationStyles">
    {{ formState?.messages?.required || formState?.messages?.invalid || '' }}
  </div>
}

<ng-template #textTpl>
  <div class="input" [style]="inputStyles" [class.validation-error]="hasValidationError">
    @for (item of displayedOptions; track item) {
      <blaze-checkbox
        class="{{ elementKeyRoot }} {{ elementKey }}"
        [style]="maxLayoutColumn"
        [checked]="selection.isSelected(item)"
        [readonly]="isReadonly"
        checkboxStyle="bat"
        [value]="item[valueField]"
        (change)="selection.toggle(item)"
        >{{ item | optionLabel: labelField }}
      </blaze-checkbox>
    }
  </div>
</ng-template>

<ng-template #imageTpl>
  @if (!!displayedOptions) {
    <blaze-item-selector
      selectionMode="multiple"
      [ngClass]="{
        'tile-group': true,
        'validation-error': hasValidationError,
        'w-full': layout === 'column',
      }"
      [options]="displayedOptions"
      [selected]="selectedItems"
      [isReadOnly]="isReadonly"
      [compareBy]="datasetCompareBy"
      itemClass="flex-shrink-0 max-w-full"
      [containerClass]="{
        'tile-group-container': true,
        'align-columns': layout === 'column',
      }"
      [containerStyle]="inputStyles"
      (selectedChange)="onSelectChange($event)"
    >
      <ng-template let-option let-selected="selected">
        @if (mode === 'image' || mode === 'box' || mode === 'chip' || mode === 'card') {
          <blaze-selectable-tile
            [style]="tileStyles"
            [labelStyles]="labelStyles"
            [class.selected-tile]="selected"
            [selected]="selected"
            [showCheckmark]="showCheckmark"
            [imageSrc]="option[imageField]"
            [showImage]="showImage"
            [icon]="option[iconField]"
            [showIcon]="showIcon"
            [imageSettings]="imageSettings"
            [iconSettings]="iconSettings"
            [labelPosition]="imageLabelPosition"
            [tileAlign]="cardAlign"
            [label]="option | optionLabel: labelField"
            [mode]="mode"
            [subLabel]="mode === 'box' ? option[boxSubTextField] : undefined"
            [subLabelStyles]="subTextStyles"
            [cardContent]="cardContentForOption()(option)"
            [cardStyles]="(cardStyles$ | async) || undefined"
            [isReadOnly]="isReadonly"
          />
        }
      </ng-template>
    </blaze-item-selector>
  }
</ng-template>
